import { Box, FormControlLabel, Switch, Typography } from '@mui/material'
import SearchNovedades from './SearchNovedades'
import ListadoNovedades from './ListadoNovedades'
import { TabsContent } from '@radix-ui/react-tabs'
import { MenuTabs } from '../../../types'
import { useContext } from 'react'
import { IntegracionesContext } from '../../../context/integraciones.context'

const IntegracionesNovedades = () => {
  const { tiendaSeleccionada } = useContext(IntegracionesContext)

  return (
    <TabsContent
      value={MenuTabs.Novedades}
      className="w-100"
      style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}
    >
      <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
        Novedades de los productos que agregaste desde {tiendaSeleccionada.name}
      </Typography>
      <Box display="flex" justifyContent="space-between" width="100%">
        {/* <AccionesMasivas /> */}
        <Box display="flex" gap="8px" alignItems="center">
          <Typography color="#8E8E8E" fontWeight="medium" fontSize={{ xs: 12, sm: 14, md: 16 }}>
            Aplicar automáticamente todos los cambios
          </Typography>
          <FormControlLabel control={<Switch />} label="" />
        </Box>
        <SearchNovedades />
      </Box>

      {/* Listado Novedades */}
      <ListadoNovedades />
    </TabsContent>
  )
}

export default IntegracionesNovedades
